<template>
  <v-app style="background-color:white;margin-top:0px">
     <!-- <div style="padding-top:-10px;background-color:#F8F8F8">
         <p style="text-align:center;padding-top:15px">
            <span @click="home()" class="hvr txt">Home</span> / <span style="color:#EA0202" class="txt">Contact Us</span></p>
     </div> -->
     <div class="kolkata5 res">
         <v-layout row wrap class="container">
            <v-flex xs12 sm12 md6 lg12>
                 <h1 style="padding:25px;color:whitesmoke;">Meet a Counsellor</h1>
            </v-flex>
         </v-layout>
     </div>
     <div class="kolkata5 man">
          <v-layout row wrap class="container" style="margin-top:50px">
              <v-flex xs12 sm12 md6 lg12 >
                  <h1 style="padding:15px;color:whitesmoke;">Meet a Counsellor</h1>
              </v-flex>
          </v-layout>
      </div>
     
     <div class="about-us-img" style="background-image: url(https://img.freepik.com/free-photo/gray-abstract-wireframe-technology-background_53876-101941.jpg?w=1380&t=st=1671442219~exp=1671442819~hmac=595292551af6e339a363a543b07aac571039b6bd50e4a40ab56626fb40538c9d) ;background-repeat: no-repeat;background-size: cover; padding-top: 100px;padding-bottom: 150px;">

        <v-container>
            <v-layout row wrap>
                <v-flex xs12 sm12 md3></v-flex>
                <v-flex xs12 sm12 md6>
                    <v-card flat elevation="14">
                      <div style="text-align:right;padding:5px;">
                      <v-icon :size="25" @click="home()">close</v-icon>
                      </div>
                        <v-container v-if="otp==false">
                          <v-form ref="form" v-model="valid" lazy-validation>  
                            <v-layout row wrap style="padding:50px;margin-top:-30px;">
                            <v-flex xs12>
                                <h1 style="text-align:center;padding-top:5px;font-weight:bold" class="txt">Meet a Counsellor</h1>
                            </v-flex>

                            <v-flex xs12 sm12 md6 style="padding-right:5px">
                                <v-text-field v-model="form.name" label="Name *" :rules="emptyRule" required></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md6 >
                                <v-text-field v-model="form.email" label="Email *" :rules="[rules.email]" required></v-text-field>
                            </v-flex>
                            <v-flex xs12 >
                                <v-text-field v-model="form.subject" label="Mobile Number *" :rules="[rules.mobileno]" required></v-text-field>
                            </v-flex>
                            <v-flex xs12 >
                                <v-textarea v-model="form.msg" label="Your Message *" :rules="emptyRule" required></v-textarea>
                            </v-flex>
                            <v-flex xs12 style="padding-bottom:12px;text-align:center;" >
                              <b-form-checkbox v-model="status"> Accept Worldwin <span @click="termdialog=true" class="hvr" style="color:#0061bc;">Terms & Conditions</span> and <span @click="privacydialog=true" class="hvr" style="color:#0061bc;">Privacy Policy</span></b-form-checkbox>
                            </v-flex>
                            <v-flex xs12 >
                                <v-btn style="border-radius:50px" dark :loading="btnSave" depressed color="#EA0202" large block @click="getOtp()">Send Message</v-btn>
                            </v-flex>
                        </v-layout>
                          </v-form>
                        </v-container>

                        <v-container v-if="otp==true">
                          <div style="text-align:right;padding:5px;">
                           <v-icon :size="25" @click="back()">close</v-icon>
                          </div>
                          <v-form ref="form1" v-model="valid" lazy-validation>  
                            <v-layout row wrap style="padding:50px;margin-top:-30px;">
                            <v-flex xs12>
                                <h3 style="text-align:center;padding-top:5px;font-weight:bold" class="txt">Verify Your mobile number</h3>
                            </v-flex>

                            <v-flex xs12 sm12 md12 style="padding-right:5px">
                                <v-text-field v-model="form1.otp" label="Enter Your OTP here *" :rules="emptyRule" required></v-text-field>
                            </v-flex>
                            <v-flex xs12 >
                                <v-btn style="border-radius:50px" dark :loading="btnSave1" depressed color="#EA0202" large block @click="onSubmit()">Vefity Now</v-btn>
                            </v-flex>
                        </v-layout>
                          </v-form>
                        </v-container>
                    </v-card>
                </v-flex>
                <v-flex xs12 sm12 md3></v-flex>
            </v-layout>
        </v-container>
     </div>
     <!-- <div class="wpb_map_wraper">
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7367.613767667471!2d88.425494!3d22.586325!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6d97c8497d3943c1!2sWorldwin%20Education%20Institute%20-%20Study%20Abroad%20%26%20Overseas%20education%20consultant%2C%20Admission%20in%20UK%20USA%20Canada%20NZ%20Aus%20Europe%20Singapore%20Dubai..%2C%20Entrance%20coaching%20class%20(%20IELTS%20TOEFL%20SAT%20CAT%20MAT).!5e0!3m2!1sen!2sin!4v1641017788565!5m2!1sen!2sin" width="100%" height="250" style="border:0;" allowfullscreen="" loading="lazy"></iframe>  
     </div> -->
     <v-dialog v-model="dialog" width="500px" persistent>
         <v-card>
           <div style="height:150px;background-color:green;text-align:center;">
             <div style="padding-top:25px;">
                <v-icon style="border:1px solid;border-radius:50px;border-color:white;" color="white" :size="80">check</v-icon>
             </div>
           </div>
           <v-container>
             <div style="text-align:center">
                 <h4>Thank You</h4>
                 <h5 class="txt" style="padding-bottom:15px;">Our Counsellors will get back to you !!</h5>
                 <v-btn depressed large color="error" @click="cancel()">Yes Understand</v-btn>
             </div>
           </v-container>
         </v-card>
     </v-dialog>

     <v-dialog v-model="termdialog" width="850px" persistent>
         <v-card>
           <div style="text-align:right;">
             <v-icon color="red" @click="termdialog=false">cancel</v-icon>
           </div>
           <v-container>
             <h1 style="text-align:center;padding-bottom:25px;">Terms & Condition</h1>
             
             <div class="scroll">
               <h5>Applicability</h5>
             <p class="txt">
               These Terms govern your access and use of our website [https://www.worldwin.co.in/]. By accessing or using our website in any way, including as an unregistered website visitor, you agree to be bound by these Terms and our Privacy Policy (also available on the website). These Terms apply to your use of our website, and the content made available on or through the website. Other services offered by us may require you to execute separate agreements or agree to other terms as applicable.
             </p>
             <h5>Legally binding</h5>
             <p class="txt">
               These Terms constitute a legally binding contract. The Terms shall be in effect as on the date you use or access any of our services.
             </p>
             <h5>Content</h5>
             <p class="txt">
               The text, images, videos, audio clips, software and other content generated, provided, or otherwise made accessible on or through the website (collectively, "Content") are contributed by us and our licensors. The Content is protected by international copyright laws. We and our licensors retain all proprietary rights in the website and the Content made available on or through the website, and, no rights are granted to any Content. Subject to these Terms, we grant each user of the website a worldwide, non-exclusive, non-sublicensable and non-transferable license to use (i.e., to download and display locally) Content solely for viewing, browsing and using the functionality of the website. Any commercial or promotional distribution, publishing or exploitation of our services or content related to our services is strictly prohibited.
               All Content is for general informational purposes only. We reserve the right, but do not have any obligation to monitor, remove, edit, modify or remove any Content, in our sole discretion, at any time for any reason or for no reason at all.
             </p>
             </div>
           </v-container>
         </v-card>
     </v-dialog>

     <v-dialog v-model="privacydialog" width="850px" persistent>
         <v-card>
           <div style="text-align:right;">
             <v-icon color="red" @click="privacydialog=false">cancel</v-icon>
           </div>
           <v-container>
             <h1 style="text-align:center;padding-bottom:25px;">Privacy Policy</h1>
             
             <div class="scroll">
               <p class="txt">
                 We are committed to maintaining your trust by protecting your personal information. This Privacy Policy (‘Policy’) describes the information we gather on our website or through our website services, applications, or other services as well as any offline products, programs or courses, how we use such information, and the steps we take to protect such information. By visiting our website, using our online services, by downloading our mobile app, or by purchasing or using our services, you accept the privacy practices described in this Policy.
               </p>
               <h5>The Information We Collect</h5>
             <p class="txt">
               We collect different information depending on our engagement with you and the requirements of applicable law as described below.
               When you use our website, you provide us data through a variety of ways. This information includes your name, number, e-mail and service interest. We also collect information regarding your profile.
               We collect the information: (a) that you provide to us directly; (b) that your parent, or guardian provides to us; (c) about your use of our services, and (d) If you opt in to certain features or depending on your device settings, we obtain geo-location data.
             </p>
             <h5>Usage of the Information</h5>
             <p class="txt">
               We use the information we collect to operate our business and provide you with quality service. The extent of our usage is contingent on which services you use, how you use them, and any preferences you may have. Illustratively, we use your information to:
               Provide services and improve your experience: We use information about you to respond to your queries, comments and concerns, provide customer and technical support, and operate and maintain the services.
               Improve our services and customer support: We use the information to understand and analyze the usage trends and queries received from you to improve our services and support.
               Send emails and other communications: We may also send communications to notify you of new information and improvements in our services.
               Comply with applicable law: We use the information to comply with our legal obligations and enforce our legal rights, such as, among other things, to exercise contractual rights, to comply with financial reporting obligations in accordance with applicable law.
             </p>
             <h5>To Whom We Disclose Information</h5>
             <p class="txt">
               We disclose your information in limited circumstances to members of Worldwin, our service providers, and other end users, in order to provide our services and to improve your experience. Where required by applicable law, we will only share your information with particular third parties with your consent.
               In exceptional circumstances, we may share information about you with a third party if we believe that sharing is reasonably necessary to (a) comply with any applicable law, regulation, or court order, (b) enforce our agreements, policies and terms of service, (c) defend ourselves against any claims or allegations, and (d) protect Worldwin from fraudulent, abusive, or unlawful use or activity.
             </p>
             </div>
           </v-container>
         </v-card>
     </v-dialog>

     <!-- <v-layout class="form-container about-us-img" row wrap>
        <v-flex xs12 sm12 md6>
            <div class="container">
                
            </div>
        </v-flex>

        <v-flex xs12 sm12 md6>
            <div class="container">
                <span><v-icon>call</v-icon>Call for help now!<br/>
                <span>033</span></span>
            </div>
        </v-flex>
     </v-layout> -->
  </v-app>
</template>

<script>
//import VueEasyLightbox from 'vue-easy-lightbox';
import GoTop from '@inotom/vue-go-top';
import config from "../../config.json";
import moment from 'moment';
export default {
  components: {
    GoTop
  },
  data() {
    return {
      valid: true,
      isLoading: false,
      text: null,
      read: false,
      btnSave: false,
      btnSave1: false,
      dialog: false,
      termdialog: false,
      privacydialog: false,
      pin: 0,
      otp: false,
      name: [],

      form: {
          name: null,
          email: null,
          subject: null,
          msg: null
      },

      form1: {
        otp: null
      },
      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
        },
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },

      
    };
  },
  
   mounted() {
   },

 methods: {
    home(){
        this.$router.push(`/worldwin`);
    },

    getOtp() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNumber: JSON.parse(this.form.subject),
              msg: this.form.msg,
              page: 'Meet a counsellor',
              course: null,
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.form.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }
            this.axios
          .post(
            `https://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.form.subject),
              cmsId: JSON.parse(res.data.result.id),
              email: this.form.email,
              guardianName: null,
              guardianNo: 0,
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: null,
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null,
              comment: this.form.msg,
              pageName: 'Meet a counsellor',
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave = false;
          });
        /* this.pin = Math.floor(1000 + Math.random() * 9000);
        this.axios
          .post(
            config.API + 'enquiry/otp',
            {
              name: this.form.name,
              mobileNumber: JSON.parse(this.form.subject),
              otp: this.pin
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.otp = true;
            this.btnSave = false;
          })
          .catch(() => {
            this.$toaster.error("Mobile number already exists!!");
            this.btnSave = false;
          }); */
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    back() {
      this.otp = false;
    },

    onSubmit() {
    },

    onSubmit1() {
      this.btnSave1 = true;
        this.axios
          .post(
            config.API + `enquiry/author`,
            {
              name: this.form.name,
              email: this.form.email,
              mobileNumber: JSON.parse(this.form.subject),
              country: this.form.msg,
              source: 'Worldwin website',
              page: 'meet a counsellor',
              course: null,
              date: moment().format('MMMM Do YYYY')
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(res => {
            console.log(res);
            this.name = this.form.name.split(' ');
            let firstName = this.name[0];
            let lastName = null;

            if(this.name.length > 2) {
              lastName = this.name[1] + this.name[2]
            }
            else {
              lastName = this.name[1]
            }
            this.axios
          .post(
            `http://api.worldwin.org/api/Leads1`,
            {
              firstName: firstName,
              lastName: lastName,
              mobileNumber: JSON.parse(this.form.subject),
              cmsId: JSON.parse(res.data.result.id),
              email: this.form.email,
              guardianName: null,
              guardianNo: 0,
              guardianEmail: null,
              relation: null,
              address: null,
              nature: null,
              source: 'Worldwin website',
              page: 'meet a counsellor',
              document: false,
              documentType: null,
              notes: null,
              levelId: 0,
              leadDetails: null,
              leadTrainings: null
            },
            {
              headers: {
                Authorization: "bearer " + localStorage.getItem("token")
              }
            }
          )
          .then(res => {
            this.dialog = true;
            this.btnSave1 = false;
          })
          .catch(() => {
            this.$toaster.error(`Mobile no is already registered`);
            this.btnSave = false;
          });
          })
          .catch(() => {
            this.$toaster.error("Mobile no is already registered");
            this.btnSave1 = false;
          });
    },

    cancel() {
        this.$refs.form.reset();
        this.otp = false;
        this.dialog = false;
    }
 },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200&display=swap');
</style>

<style scoped>
.txt {
  font-family: 'Montserrat', sans-serif !important;
}
.about-us-img {
    background-image: url('https://sasitechnologies.in/csquad/assets/images/bg/bg-2.png');
    background-size: cover;
}
.zero {
    color: #4e97fd;
    font-size: 150px;
}
.covid {
  font-family: 'Quicksand', sans-serif;
  font-weight: bold;
}
.rotate-image {
  animation: mymove 3s infinite;
}
@keyframes mymove {
  100% {transform: rotate(360deg);}
}
.kolkata5 {
    background-image: linear-gradient(to bottom,rgba(187, 35, 35, 0.73), rgba(58, 18, 18, 0.73)), url('../../assets/popular_course.jpg');
    background-size: cover;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.hvr :hover {
    color: #EA0202 !important;
}
.debashis {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>
